import React, { Component } from 'react';

import { cf } from './cf';
import { ce } from './ce';
import { ic } from './ic';
import { bf } from './bf';

import { iv } from './iv';
import { cp } from './cp';

import cView from './cView';

class cUserDtl extends cView {

  $id_stgs = {
    b_useCm11: false,
    b_useCm12: false,
  };

  $cd_stss = {
    //
    s_cm10b21k: '', // 利用者グループcm20_key
    s_cm10c310: '', // 氏名・名称
    s_cm10c320: '', // フリガナ
    s_cm10c330: '', // ニックネーム・源氏名
    s_cm10c410: '', // 利用者区分
    s_cm10cz10: '', // 表示区分
    s_cm10i110: '', // メール
    //
    s_cm11i110: '',
    s_cm11i120: '',
    s_cm11i130: '',
    s_cm11i210: '', // 生年月日
    //
    s_cm12i210: '',
    s_cm12i220: '',
    s_cm12i230: '',
    s_cm12i240: '',
    s_cm12i250: '',
    s_cm12i260: '',
    s_cm12i270: '',
  };

  $clp_loads = () => [

/*
    cp.$cp_load_cm10({
      b_clr: (global.c?.state.sgc_pageMode == 'new') ? true : false,
      mode: 'set',
      cnd: bf.q(`[_KEY]={}`.f(global.c?.state.sgcd_pagePntKeys.cm10_key)),
    }),
*/
    new Promise( _o_end1 => {
      cp.$cp_load_cm10({
        b_clr: (global.c?.state.sgc_pageMode == 'new') ? true : false,
        mode: 'set',
        cnd: bf.q(`[_KEY]={}`.f(global.c?.state.sgcd_pagePntKeys.cm10_key)),
      })
      .then(() => {
        global.c?.setState({
          sgcd_pagePntKeys: bf.p(global.c?.state.sgcd_pagePntKeys, _next => {
            _next.cm10c410 = global.c?.state.s_cm10c410;
          }),
        }, () => {
          _o_end1();
        });
      });
    }),

    cp.$cp_hlr_cm11({
      mode: 'set',
      b_clr: (global.c?.state.sgc_pageMode == 'new') ? true : false,
//      cm10_key: global.c?.state.sgcd_pagePntKeys.cm10_key,
      cnd: bf.q(`[cm11b11k]="{}"`.f(global.c?.state.sgcd_pagePntKeys.cm10_key)),
    }),

    new Promise( _o_end1 => { // 利用者属性情報 #2
      //
      if (
        global.c?.$id_stgs.b_useCm12 == true &&
        global.c?.state.sgc_pageMode == 'show'
      ) {
        let _cnd = bf.q('[cm12b11k]="{}"'.f(
          global.c?.state.sgcd_pagePntKeys.cm10_key,
        ));
        cf.myCB_call_slc({
          ctr: 'nlm', 
          elm: 'cm12', 
          n_dms: 2, 
          cnd: _cnd
        }) // pageKey ではなく pagePntKey
        .then((_d_cm12s) => {
          //
          global.c?.setState({
            s_cm12i210: _d_cm12s.cm12i210 || '',
            s_cm12i220: _d_cm12s.cm12i220 || '',
            s_cm12i230: _d_cm12s.cm12i230 || '',
            s_cm12i240: _d_cm12s.cm12i240 || '',
            s_cm12i250: _d_cm12s.cm12i250 || '',
            s_cm12i260: _d_cm12s.cm12i260 || '',
            s_cm12i270: _d_cm12s.cm12i270 || '',
          }, ()=>{
            _o_end1();
          })
        })
      }
      else {
        _o_end1();
      };
    }),
  ];

  $cp_ins = () => new Promise( _o_end1 => {
//bf.l('95: here')
    cf.myRN_user_ins(global.c?.state.s_cm10i110)
    .then((_d_cm10s)=>{
//bf.l('98: {}'.f(_d_cm10s))
      global.c?.setState({
        sgcd_pagePntKeys: bf.p(global.c?.state.sgcd_pagePntKeys, _next => {
          _next.cm10_key = _d_cm10s._KEY;
          _next.cm10c310 = global.c?.state.s_cm10c310;
        }),
      }, ()=>{
        _o_end1(_d_cm10s);
      })
    });
  });

  $clp_upds = () => [

    cp.$cp_upd_cm10(),

    cp.$cp_hlr_cm11({
      mode: 'ups',
//      cm10_key: global.c?.state.sgcd_pagePntKeys.cm10_key,
//      cm10_key: global.c?.state.sgc_pageKey,
      cnd: bf.q(`
        [_KEY]={}
      `.f(
        global.c?.state.sgcd_pagePntKeys.cm10_key
      )),
    }),

    new Promise( _o_end1 => { // 利用者属性情報#2
      //
      if (global.c?.$id_stgs.b_useCm12 == true) {
        //
        let _d_vals = {
          cm12b11k: global.c?.state.sgcd_pagePntKeys.cm10_key,
//          cm12b11k: global.c?.state.sgc_pageKey,
          cm12i210: global.c?.state.s_cm12i210 || '',
          cm12i220: global.c?.state.s_cm12i220 || '',
          cm12i230: global.c?.state.s_cm12i230 || '',
          cm12i240: global.c?.state.s_cm12i240 || '',
          cm12i250: global.c?.state.s_cm12i250 || '',
          cm12i260: global.c?.state.s_cm12i260 || '',
          cm12i270: global.c?.state.s_cm12i270 || '',
        };
        let _cnd = bf.q('[cm12b11k]="{}"'.f(global.c?.state.sgcd_pagePntKeys.cm10_key))
//        let _cnd = bf.q('[cm12b11k]="{}"'.f(global.c?.state.sgc_pageKey))
        cf.myCB_call_iud({
          ctr: 'ups', 
          elm: 'cm12', 
          d_vals: _d_vals, 
          cnd: _cnd
        })
        .then((_d_res)=>{
          _o_end1();
        });
      }
      else {
        _o_end1();
      };
    }),

  ];

  render() {
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_alwEdit={false}
        b_rhtVsb={true}
        rhtPfx={null}
        onRhtPrs={null}
        b_entBtnVsb={true}
        n_bdyW={ic.gn_maxBdyW}
        d_hdrs={{
          pfx: iv._get_hdrPfx('ユーザ情報'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgc_pageMode),
        }}
        d_bdys={{
          ld_defss: [
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm10i110',
              pfx:'メール',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm10c310',
              pfx:'名前',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm11i130',
              pfx:'電話番号',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm12i210',
              pfx:'振込先銀行コード',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm12i220',
              pfx:'振込先銀行名',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm12i230',
              pfx:'振込先支店コード',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm12i240',
              pfx:'振込先支店名',
              b_mln:false,
            },
            {
              type:'Pck',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm12i250',
              pfx:'振込先口座種別',
              dd_listItemss:{
                '10':{key:'10', pfx: '普通'},
                '20':{key:'20', pfx: '当座'},
              },
              b_setValOnChg:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm12i260',
              pfx:'振込先口座番号',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm12i270',
              pfx:'振込先口座名',
              b_mln:false,
            },
            {
              type:'Pck',
              b_vsb:(ic.gb_dbg || global.c?.state.sgc_cm10_key == -1 || bf.i(global.c?.state.sgc_cm10c410, ['90'])) ? true : false,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm10c410',
              pfx:'利用者区分 ※運営者のみ表示',
              dd_listItemss:{
                  '10':{key:'10', pfx: '会員'},
                  '90':{key:'90', pfx: '運営者'},
              },
              b_setValOnChg:false,
            },
            {
              type:'Pck',
              b_vsb:(bf.i(global.c?.state.sgc_cm10c410, ['90'])) ? true : false,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm10cz10',
              pfx:'表示の有無　※運営者のみ表示',
              dd_listItemss:{
                  '10':{key:'10', pfx: '表示する'},
                  '0':{key:'0', pfx: '表示しない'},
              },
            },
          ],
        }}
      />
    );
  };
};

export default cUserDtl;
